<script setup>
import { ref, onMounted, computed } from 'vue';
import DOMPurify from 'dompurify';
import TestimonialCard from '@/views/resources/learningHub/TestimonialCard.vue';

const props = defineProps({
  body: {
    type: String,
    required: true,
  },
  title: String,
  slug: String,
  id: String,
  metaDescription: String,
  tags: Array,
  // Accept the featuredExperts array from parent
  featuredExperts: {
    type: Array,
    default: () => []
  },
});

const finalBody = computed(() => props.body);
const finalHtml = ref('');

onMounted(async () => {
  if (!finalBody.value) return;

  const parsedHtml = DOMPurify.sanitize(finalBody.value);
  const parser = new DOMParser();
  const doc = parser.parseFromString(parsedHtml, 'text/html');
  const headings = doc.querySelectorAll('h1, h2, h3, h4, h5, h6');

  headings.forEach((heading) => {
    if (!heading.id && heading.textContent) {
      heading.id = heading.textContent
        .trim()
        .toLowerCase()
        .replace(/\s+/g, '-')
        .replace(/[^\w]+/g, '-');
    }
  });

  finalHtml.value = doc.documentElement.outerHTML;
});
</script>

<template>
  <div class="container">
    <v-row class="body">
      <v-col cols="12" md="11">
        <div class="finalHtmlBody" >
          <div v-if="finalHtml" class="banner">
            <div class="pd-1">
              <v-row>
                <v-col cols="12" lg="9">
                  <div class="js-toc-content prose" v-html="finalHtml" />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" lg="9">
                  <!-- Featured Experts Section -->
                  <div v-if="featuredExperts && featuredExperts.length > 0" >
                    <h3 class="headline">
                      {{ featuredExperts.length === 1 ? 'Featured Expert:' : 'Featured Experts:' }}
                    </h3>
                    
                    <!-- Grid layout for testimonial cards -->
                    <div class="experts-grid" >
                      <TestimonialCard
                        v-for="expert in featuredExperts"
                        :key="expert.id"
                        :presenter-description="expert.description"
                        :presenter-image="expert.image"
                        :presenter-name="expert.name"
                        :presenter-title="expert.title"
                      />
                    </div>
                  </div>
                </v-col>
              </v-row>
            </div>
          </div>
        </div>
        
        
      </v-col>
    </v-row>
  </div>
</template>

<style scoped>
.container {
  align-items: center;
  justify-content: center;
  align-content: center;
  position: relative;
}

.body {
  max-width: 1250px;
  align-items: center;
  /* justify-content: center; */
  align-content: center;
}

.headline {
  margin-bottom: 1rem;
}

/* Grid layout for expert cards */
.experts-grid {
  display: flex;
  flex-wrap: wrap;
  /* grid-template-columns: repeat(auto-fit, minmax(320px, 2fr)); */
  gap: 1rem;
  margin-bottom: 2rem;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .experts-grid {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
}

@media (min-width: 1200px) {
  .experts-grid {
    grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
    gap: 1rem;
  }
}
@media only screen and (max-width: 1280px){
  .banner {
    padding: 0 5rem;
  }
}
@media only screen and (max-width: 1050px){
  .banner {
    padding: 0 4rem;
  }
}
@media only screen and (max-width: 840px){
  .banner {
    padding: 0 3rem;
  }
}
@media only screen and (max-width: 640px){
  .banner {
    padding: 0 2rem;
  }
}
@media only screen and (max-width: 470px){
  .banner {
    padding: 0 1rem;
  }
}
</style>